import React from "react";

const Details = () => {
  const styles = {
    container: {
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      padding: "10px",
    },
    column: {
      flex: 1,
      padding: "20px",
      color: "white",
      fontFamily: "Arial, sans-serif",
      margin: "5px",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    yellow: {
      backgroundColor: "#fde6a1",
      color: "#000",
    },
    orange: {
      backgroundColor: "#fbb7a2",
      color: "#000",
    },
    pink: {
      backgroundColor: "#fcb8d2",
      color: "#000",
    },
    blue: {
      backgroundColor: "#a4bdfc",
      color: "#000",
    },
    teal: {
      backgroundColor: "#9de8db",
      color: "#000",
    },
    responsive: {
      flexDirection: "column",
    },
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{ ...styles.container, ...(isMobile ? styles.responsive : {}) }}>
      <div style={{ ...styles.column, ...styles.yellow }}>
        <h2>⏰ Timing</h2>
        <p>
        👉  Mon-Sat : 7:30am – 1:00pm <br/>(Summer Timings)
<br/>
👉 Mon-Sat : 8:30am – 2:00pm<br/> (Winters Timings)
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.orange }}>
        <h2>📌 Address</h2>
        <p>
        👉 J.K Ashiyana, Kareli, Prayagraj <br/>    Uttar Pradesh
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.pink }}>
        <h2>💬 Email</h2>
        <p>
        👉  jniinst786@gmail.com <br/>
        </p>
      </div>
      <div style={{ ...styles.column, ...styles.blue }}>
        <h2>📞 Phone</h2>
        <p>
        👉 <a href="tel:+919005084268" style={{ color: 'inherit', textDecoration: 'none' }}>+919005084268</a><br/><br/>
        👉 <a href="tel:+915324072008" style={{ color: 'inherit', textDecoration: 'none' }}>+915324072008</a>
        </p>
      </div>
    </div>
  );
};

export default Details;
